export const TOGGLE_SURVEY_PREVIEW_EDITOR_HEADER =
  'TOGGLE_SURVEY_PREVIEW_EDITOR_HEADER';
